import * as React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CheckPermissions, GetQuery, GetSystemCompanyId } from './Shared';

const AdminListData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [systemCompanyId, setSystemCompanyId] = React.useState(2);
    const [canUpdateReckonFilename, setCanUpdateReckonFilename] = React.useState(false);
    const [canUploadSystemFiles, setCanUploadSystemFiles] = React.useState(false);
    const [canEditItems, setCanEditItems] = React.useState(false);
    const [canEditPublicHols, setCanEditPublicHols] = React.useState(false);
    const [canEditTrucks, setCanEditTrucks] = React.useState(false);
    const [canViewUpdatePricelists, setCanViewUpdatePricelists] = React.useState(false);

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("CreateEditAdminLists");
        if (hasPermission) {
            getSystemCompany();
        } else {
            navigate("/accessdenied");
        }
    }

    const getSystemCompany = async () => { 
        var sysCompId = await GetSystemCompanyId();

        if (sysCompId === 0) {
            toast.error("Error getting data!");
        } else {
            setSystemCompanyId(sysCompId);
            checkReckonPermission();
        }
    }

    const checkReckonPermission = async () => {
        const apiUrl = "CheckAdminPermission";
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setCanUpdateReckonFilename(result.data.canUpdateReckonFileName);
            setCanUploadSystemFiles(result.data.canUploadSystemFiles);
            setCanEditItems(result.data.canEditItems);
            setCanEditPublicHols(result.data.canEditPublicHols);
            setCanEditTrucks(result.data.canEditTrucks);
            setCanViewUpdatePricelists(result.data.canViewUpdatePricelists);
            setLoading(false);
        } 
    }

    //const handleImportCustomers = (e: any) => {
    //    var files = e.target.files[0];
    //    importCustomers(files);
    //}

    //const importCustomers = async (file: File) => {

    //    //import jobs from drums
    //    const data = new FormData()
    //    data.append('csvFile', file);

    //    axios('api/Admin/ImportCustomers', {
    //        headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
    //        method: 'POST',
    //        data: data,
    //        responseType: 'blob' //Force to receive data in a Blob Format
    //    })
    //    .then(res => {
    //        //DOWNLOAD FILE TO BROWSER
    //        const url = window.URL.createObjectURL(new Blob([res.data]));
    //        const link = document.createElement('a');
    //        link.href = url;
    //        link.setAttribute('download', 'Drums Failed Import Customers.csv');
    //        document.body.appendChild(link);
    //        link.click();
    //        toast.success("Customers imported into Dash successfully!");
    //    })
    //    .catch(error => {
    //        toast.error(error.message);
    //    });
    //}

    //const handleCustomerUpdateScaffold = (e: any) => {
    //    e.preventDefault();
    //    toast.info("Running Scaffold Customers");
    //    updateCustomers(2);
    //}

    //const handleCustomerUpdateDunny = (e: any) => {
    //    e.preventDefault();
    //    toast.info("Running Dunny Customers");
    //    updateCustomers(3);
    //} 

    //const updateCustomers = async (companyId: number) => {
    //    setError("");

    //    //enter the page that reckon needs to return to, id blank as not used via invoicing
    //    var page = {
    //        page: "adminlists",
    //        id: 0
    //    };
    //    //encode to base 64 so can retrieve it later
    //    var encoded = window.btoa(JSON.stringify(page));

    //    axios.get('api/Customer/ReckonCustomerAuthoriseCheck?returnUrl=' + encoded + '&SubId=' + user.sub, {
    //        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    //    })
    //    .then(res => {
    //        //continue if Quick Books user is authorised
    //        if (res.data.isAuthorised) {
    //            linkCustomersToReckon(companyId)
    //        } else if (!res.data.reckonSwitchedOn) {
    //            //need to have reckon switched on to update customers
    //            toast.error("Reckon isn't switched on!");
    //        } else {
    //            window.location.replace(res.data.reckonLoginUrl)
    //        }
    //    })
    //    .catch(error => {
    //        toast.error(error.message);
    //    });
    //}

    //const linkCustomersToReckon = async (companyId: number) => {
    //    var data = {
    //        companyId: companyId
    //    };

    //    axios.post('api/Customer/LinkCustomersToReckon', data, {
    //        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    //    })
    //    .then(res => {
    //        toast.success("Customers Linked to Reckon Successfully");
    //    })
    //    .catch(error => {
    //        this.setState({ error: error.message });
    //        toast.error(error.message);
    //    });
    //}

    const renderDetails = (
        <div>
            <div className={canViewUpdatePricelists ? "" : "hidden"}>
                <div className={systemCompanyId === 2 ? "hidden" : "adminlists__item"}>
                    <NavLink to={'/pricelistsetweeks'}>
                        Price List Set Weeks
                    </NavLink>
                </div>
                <div className="adminlists__item">
                    <NavLink to={'/pricelists'}>
                        {systemCompanyId === 2 ? "Price Lists" : "Price List - EWS / Site Building"}
                    </NavLink>
                </div>
                <div className={systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/pricelistkwikstage'}>
                        Price List - Kwikstage
                    </NavLink>
                </div>
                <div className={systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/pricelisttowers'}>
                        Price List - Towers
                    </NavLink>
                </div>
                <div className={systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/pricelistepa'}>
                        Price List - EPA
                    </NavLink>
                </div>
                <div className={systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/pricelistpumpclean'}>
                        Price List - Pump & Cleans / Relocate Toilet/Power Pole
                    </NavLink>
                </div>
                <div className={systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/pricelistfencing'}>
                        Price List - Fencing
                    </NavLink>
                </div>
                <div className={systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/pricelistfencingcustom'}>
                        Price List - Fencing Custom
                    </NavLink>
                </div>
                <div className={systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/pricelistevent'}>
                        Price List - Events
                    </NavLink>
                </div>
                <div className={systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/pricelistcustom'}>
                        Price List - Custom
                    </NavLink>
                </div>
                <div className={systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/pricelistpowerpoleconnection'}>
                        Price List - Power Pole Connections
                    </NavLink>
                </div>
                <div className={systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/surcharges'}>
                        Surcharges
                    </NavLink>
                </div>
                <div className = "adminlists__item">
                    <NavLink to={'/pricelistsettings'}>
                        {systemCompanyId === 3 ? "Cleaning, Travel, Power Pole Fees" : "Travel, Labour etc Rates"}
                    </NavLink>
                </div>
            </div>
            <div className={canEditPublicHols ? "" : "hidden"} >
                <div className={systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/publicholidays'}>
                        Public Holidays
                    </NavLink>
                </div>
                <div className={systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/shutdownperiods'}>
                        Shutdown Periods
                    </NavLink>
                </div>
            </div>
            <div className={canEditItems ? "" : "hidden"} >
                <div className={systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/itemformulas'}>
                        Item Formulas
                    </NavLink>
                </div>
                <div className={systemCompanyId === 2 ? "adminlists__item" : "hidden"}>
                    <NavLink to={'/itemphoto'}>
                        Item Photo
                    </NavLink>
                </div>
            </div>
            <div className={canEditTrucks ? "adminlists__item" : "hidden"}>
                <NavLink to={'/trucks'} >
                    Trucks
                </NavLink>
            </div>
            <div className={canUploadSystemFiles && systemCompanyId === 3 ? "adminlists__item" : "hidden"}>
                <NavLink to={'/systemfiles'}>
                    Upload System Files
                </NavLink>
            </div>
            <div className={canUpdateReckonFilename ? "adminlists__item" : "hidden"}>
                <NavLink to={'/reckondata'}>
                    Update Reckon Filename/s
                </NavLink>
            </div>

            {/*<div className={systemCompanyId === 3 ? "hidden" : "hidden"}>*/}
            {/*    <div className="marginTop10">*/}
            {/*        <span className="marginRight10">Import Customers CSV</span> <input type="file" name="file" accept=".csv" onChange={handleImportCustomers}></input>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/*<div className={systemCompanyId === 2 ? "hidden" : "hidden"}>*/}
            {/*    <div className="marginTop10">*/}
            {/*        <a href="#" className="marginRight10" onClick={(e) => handleCustomerUpdateScaffold(e)}>Link Dash Customers to Reckon Scaffold</a>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className={systemCompanyId === 3 ? "hidden" : "hidden"}>*/}
            {/*    <div className="marginTop10">*/}
            {/*        <a href="#" className="marginRight10" onClick={(e) => handleCustomerUpdateDunny(e)}>Link Dash Customers to Reckon Dunny</a>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;


    return <div>
        <h1>Admin Lists</h1>
        {contents}
    </div>;

};

export default AdminListData;